import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

/**
 * ContractMaoTaxBanner — Contract / MAO deferred-tax banner (T094 /
 * FR-010 of the Canadian-tax spec).
 *
 * Renders a single-line informational banner with the exact copy
 * mandated by FR-010:
 *
 *   "Taxes will be calculated and added to your fulfillment order."
 *
 * The EU spec (FR-013) mandates the same banner with VAT wording:
 *
 *   "VAT will be calculated and added to your fulfillment order."
 *
 * The copy is therefore passed in rather than hard-coded — the
 * container picks it from the listing currency, since which tax regime
 * applies is a jurisdiction question this presentational component has
 * no business answering.
 *
 * Contract / MAO bidding methods (% of MSRP, % of COGS — i.e.
 * `ContractDto.bidBasis === 'RELATIVE'`) have no knowable won-at
 * amount at bid-time, so the running tax estimate (FR-007) and
 * maximum tax exposure (FR-008) are suppressed and this banner is
 * shown in their place. After fulfillment, the resulting Order
 * surfaces the standard post-purchase tax breakdown via the US1
 * calc path — the per-line tax rows render inside the order details
 * Payment Due card (BuyerOrderPaymentBreakdown from fe-core).
 *
 * Wired into the listing detail page's `ActionsContainer` for
 * Contract / MAO listings by `ListingDetailsLayout` (T094), gated
 * on `listing.listingType === 'CONTRACT' && listing.contract?.bidBasis === 'RELATIVE'`
 * and on `currency === 'CAD'`.
 */

// The shared `Banner` component doesn't forward arbitrary props onto
// its outer container, so to expose a stable test hook we wrap it in
// a `<div data-testid>`. The wrapper is non-semantic — Banner already
// renders `role="status"` and our screen-reader semantics live there.
const ContractMaoTaxBanner = ({ messageId }: { messageId: string }) => (
  <div data-testid="contract-mao-tax-banner">
    <Banner type="info">
      <FormattedMessage id={messageId} />
    </Banner>
  </div>
)

export default ContractMaoTaxBanner
